import { geographiesParameters } from "./types";

export const geographiesKeys = {
  all: () => ["geographies"] as const,
  list: (filters: Partial<geographiesParameters>) =>
    [...geographiesKeys.all(), filters] as const,
};
